import { MenuItem } from '@material-ui/core';
import React from 'react';
import { TSelectOptionData } from '../common/types';

type PSelectOption = {
  index: number;
  style?: any;
  data: TSelectOptionData;
};

export const SelectOption: React.FC<PSelectOption> = (props) => {
  // Data - props passed from react-window library
  const { index, data, style = {} } = props;
  const { selected, onClick } = data;
  const option = data.options[index];
  const handleClick = () => {
    onClick(option.value);
  };
  return (
    <MenuItem
      value={option?.value}
      onClick={handleClick}
      style={{
        background: selected === option.value ? 'rgba(0, 0, 0, 0.08)' : 'unset',
        ...style,
      }}
    >
      {option.label}
    </MenuItem>
  );
};
